import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { clearUserData } from '../../features/feature1/feature1Slice'; // Uncomment if needed

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Remove the token from localStorage or any other storage
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("isLoggedIn"); // Adjust the key if your token is stored with a different name

    // Adjust the key if your token is stored with a different name

    // Optionally clear user data from Redux store
    // dispatch(clearUserData());

    // Navigate to the login page
    navigate("/login");
  }, [dispatch, navigate]);

  return null; // No need to render anything
};

export default Logout;
